/** Administration des comptes (RG-60 à RG-62), réservée au superadmin. */
import { defineStore } from 'pinia'
import { computed, ref } from 'vue'
import { errorMessage, listUsers, setUserRole } from '@/services/api'
import type { Role, UserSummary } from '@/types'

export const useAdminStore = defineStore('admin', () => {
  const users = ref<UserSummary[]>([])
  const loading = ref(false)
  const loaded = ref(false)
  const error = ref<string | null>(null)

  /** Pastille de l'onglet « Administration » (RG-62). */
  const pendingCount = computed(() => users.value.filter((u) => u.role === '').length)

  async function load(): Promise<void> {
    loading.value = true
    error.value = null
    try {
      users.value = await listUsers()
      loaded.value = true
    } catch (e) {
      error.value = errorMessage(e)
    } finally {
      loading.value = false
    }
  }

  /** Le badge n'est mis à jour qu'après confirmation du serveur (RG-61). */
  async function changeRole(uid: string, role: Exclude<Role, 'superadmin'>): Promise<void> {
    const updated = await setUserRole(uid, role)
    users.value = users.value.map((u) => (u.uid === uid ? { ...u, role: updated.role } : u))
  }

  function clear() {
    users.value = []
    loaded.value = false
  }

  return { users, loading, loaded, error, pendingCount, load, changeRole, clear }
})
